import { render, staticRenderFns } from "./CallUI.vue?vue&type=template&id=47a90fc2&scoped=true&"
import script from "./CallUI.vue?vue&type=script&lang=js&"
export * from "./CallUI.vue?vue&type=script&lang=js&"
import style0 from "./CallUI.vue?vue&type=style&index=0&id=47a90fc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a90fc2",
  null
  
)

export default component.exports